import React from 'react';

const LinkAppleAccountSvg = (props) => (
    <svg
        width="253"
        height="141"
        viewBox="0 0 253 141"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g filter="url(#filter0_dd)">
            <circle cx="70.5" cy="69.5" r="46.5" fill="#F05537" />
        </g>
        <g filter="url(#filter1_dd)">
            <circle cx="182.5" cy="69.5" r="46.5" fill="black" />
        </g>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M190.085 51.5C188.367 51.5868 186.257 52.7849 185.007 54.369C183.874 55.7826 182.898 58.0517 183.171 60.234C185.086 60.4061 187.077 59.1646 188.289 57.5805C189.499 55.9531 190.32 53.7273 190.085 51.5V51.5ZM189.934 60.2775C187.252 60.0026 184.687 61.8811 183.326 61.8811C181.965 61.8811 179.866 60.3157 177.651 60.3554C174.735 60.4333 172.053 62.0766 170.537 64.6989C167.544 70.0213 169.799 77.8485 172.752 82.1523C174.19 84.2263 175.94 86.6134 178.194 86.4958C180.371 86.4179 181.187 85.0877 183.831 85.0877C186.436 85.0877 187.213 86.4958 189.506 86.4576C191.838 86.4179 193.316 84.3042 194.754 82.192C196.426 79.7652 197.087 78.8656 197.125 78.748C197.087 78.7084 192.577 75.4996 192.5 70.2947C192.46 65.9115 196.037 63.7993 196.231 63.6817C194.209 60.7081 191.061 60.3157 189.934 60.2775V60.2775Z"
            fill="white"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M68.449 58.9328C73.0911 57.8602 77.7263 59.8006 80.3061 63.4765L59.7862 68.2112C60.491 63.7785 63.8068 60.0054 68.449 58.9328V58.9328ZM80.4207 76.3579C78.8686 78.6558 76.4764 80.3949 73.5598 81.0648C68.8864 82.1443 64.2235 80.1693 61.6541 76.4517L82.24 71.6997L85.5906 70.9256L92 69.4469C91.9618 68.0688 91.7882 66.67 91.4653 65.278C88.8578 53.9795 77.5805 46.9331 66.2789 49.5434C54.9808 52.1502 47.9325 63.4245 50.5435 74.723C53.151 86.0216 64.4283 93.0646 75.7299 90.4577C82.3893 88.92 87.5662 84.3728 90.1667 78.5899L80.4207 76.3579Z"
            fill="white"
        />
        <g filter="url(#filter2_dd)">
            <ellipse cx="126.5" cy="71" rx="27.5" ry="28" fill="white" />
        </g>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M119 74V68V66H121H126V68H121V74H126V76H119V75V74ZM130 70H124V72H130V70ZM128 66H133H135V68V74V75V76H128V74H133V68H128V66Z"
            fill="#4B4D63"
        />
        <defs>
            <filter
                id="filter0_dd"
                x="0"
                y="0"
                width="141"
                height="141"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                />
                <feOffset dy="2" />
                <feGaussianBlur stdDeviation="4" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.156863 0 0 0 0 0.172549 0 0 0 0 0.207843 0 0 0 0.1 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow"
                />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                />
                <feOffset dy="1" />
                <feGaussianBlur stdDeviation="12" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.156863 0 0 0 0 0.172549 0 0 0 0 0.207843 0 0 0 0.1 0"
                />
                <feBlend
                    mode="normal"
                    in2="effect1_dropShadow"
                    result="effect2_dropShadow"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect2_dropShadow"
                    result="shape"
                />
            </filter>
            <filter
                id="filter1_dd"
                x="112"
                y="0"
                width="141"
                height="141"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                />
                <feOffset dy="2" />
                <feGaussianBlur stdDeviation="4" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.156863 0 0 0 0 0.172549 0 0 0 0 0.207843 0 0 0 0.1 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow"
                />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                />
                <feOffset dy="1" />
                <feGaussianBlur stdDeviation="12" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.156863 0 0 0 0 0.172549 0 0 0 0 0.207843 0 0 0 0.1 0"
                />
                <feBlend
                    mode="normal"
                    in2="effect1_dropShadow"
                    result="effect2_dropShadow"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect2_dropShadow"
                    result="shape"
                />
            </filter>
            <filter
                id="filter2_dd"
                x="75"
                y="20"
                width="103"
                height="104"
                filterUnits="userSpaceOnUse"
                colorInterpolationFilters="sRGB"
            >
                <feFlood floodOpacity="0" result="BackgroundImageFix" />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                />
                <feOffset dy="2" />
                <feGaussianBlur stdDeviation="4" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.156863 0 0 0 0 0.172549 0 0 0 0 0.207843 0 0 0 0.1 0"
                />
                <feBlend
                    mode="normal"
                    in2="BackgroundImageFix"
                    result="effect1_dropShadow"
                />
                <feColorMatrix
                    in="SourceAlpha"
                    type="matrix"
                    values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                />
                <feOffset dy="1" />
                <feGaussianBlur stdDeviation="12" />
                <feColorMatrix
                    type="matrix"
                    values="0 0 0 0 0.156863 0 0 0 0 0.172549 0 0 0 0 0.207843 0 0 0 0.1 0"
                />
                <feBlend
                    mode="normal"
                    in2="effect1_dropShadow"
                    result="effect2_dropShadow"
                />
                <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="effect2_dropShadow"
                    result="shape"
                />
            </filter>
        </defs>
    </svg>
);

LinkAppleAccountSvg.displayName = 'LinkAppleAccountSvg';
export default LinkAppleAccountSvg;
